import { IconCreditCard, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import type { Item } from 'typings'
import { Tag, TagsList } from '../../../Tag'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { RuleDefaultActions } from '../../RuleStack/DefaultActions'
import { messages } from './messages'

type Props = {
  values: Item[] | undefined
  onEdit: () => void
  onRemove: () => void
}

export function PaymentMethodsView(props: Props) {
  const { values, onEdit, onRemove } = props
  const { formatMessage: i18n } = useIntl()

  if (!values) return

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconCreditCard />
      </RuleIcon>

      <RuleDescription>
        {i18n(messages.view.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
          count: values.length,
        })}
      </RuleDescription>

      <RuleContent>
        <TagsList>
          {values.map(({ name }, index) => (
            <div key={index} role="listitem">
              <Tag>{name}</Tag>
            </div>
          ))}
        </TagsList>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
